
import Analitics from "@/shared/Analitics";
import { BannerFlotante2 } from "@/shared/ContentBanner";
import DfpNews from "@/shared/DFP/News";
import Banner from "@/widgets/Banner/Templates/Banner";
import Footer from "@/shared/Footer";
import Header from "@/shared/Header";
import HeadNews from "@/shared/HeadNews";
import JWPlayer from "@/shared/JWPlayer";
import Meter from "@/shared/Meter/index.jsx";
import BannerFlotante from "@/widgets/Banner/Templates/BannerFlotante";
import { BannerCollapse } from "@/shared/ContentBanner";
import Autorefresh from "@/shared/Autorefresh";
import { VideoStory } from "./style";
import { JWPlayerContainer } from "../Nota/components/RenderBody/components/Video/style";
import { ContainerAuto } from "@/shared/ContainerAuto";
import SocialNetworking from "@/shared/SocialNetworking";
import { ContainerText } from "../Nota/components/RenderBody/components/TextBody/style";
import Viafoura from "@/shared/Viafoura";
import FormattedDate from "@/shared/FormattedDate";
import {
  DataStory,
  StoryBody,
  StoryGrid,
} from "../Nota/components/StoryContainer/Normal/style";
import LatestSlider from "@/shared/LatestSlider";
import RightColumn from "@/shared/RightColumn/index.jsx";
import {
  Authors,
  Tag,
  Recommender,
} from "@/templates/Clarin/Nota/components";
import { DiscoverNews } from "@/templates/Clarin/Nota/components";
import TemplateProvider from "@/context/Template/TemplateProvider.jsx";
import { useVideo } from "./hooks/useVideo";

const Video = (props) => {

  const { formatContent, ...rest } = useVideo(props);
  // Generar un ID único para cada reproductor
  const playerId = `jwplayer-${formatContent?.entityId || Math.random().toString(36).substr(2, 9)}`;

  return (
    <TemplateProvider data={{ ...rest, content: formatContent }} >
      <HeadNews />
      {!rest?.isPreview && <Analitics />}
      <DfpNews />
      <Header />{" "}
      <BannerFlotante isPreview={rest?.preview} slotId={"1"} />
      <BannerFlotante2>
        <BannerFlotante isPreview={rest?.preview} slotId={"2"} />
      </BannerFlotante2>
      <ContainerAuto>
        <VideoStory>
          <LatestSlider latest={formatContent?.relatedLatestVideo} title="Otros videos" iconName="play" />
          <JWPlayerContainer className="version-videoStory">
            <JWPlayer
              id={playerId}
              playerScript={formatContent?.sectionIdJWPlayer}
              entityId={formatContent?.entityId}
              thumbnail={formatContent?.thumbnail}
              title={formatContent?.name}
              type="apertura"
            />
          </JWPlayerContainer>
          <div className="title-news">
            <h1 className="video-name"><span>Video</span>{formatContent?.name}</h1>
          </div>
          <StoryGrid className="notaVideo">
            <StoryBody id="storyBody">
              <DataStory className="dataStory">
                <div className={`list-authors ${formatContent?.authors ? "has-border-top" : ""}`}>
                  <Authors />
                </div>
                <div className="place-social-mobile">
                  <SocialNetworking />
                </div>
              </DataStory>
              <FormattedDate />
              <ContainerText>
                <p dangerouslySetInnerHTML={{ __html: formatContent?.parseDescription }} ></p>
              </ContainerText>
              <div className="comments">
                {formatContent?.canHaveComments && <Viafoura idNews={formatContent?._id} />}
              </div>
              <Recommender contentId={formatContent?._id} tags={formatContent?.tags} />
              <BannerCollapse>
                <Banner slotId={"inread2"} adsPath="video/nota" />
              </BannerCollapse>
              <hr />
              <h2 className="title">Lo más visto</h2>
              <div style={{ position: "relative", overflow: "hidden", paddingBottom: "56.25%", marginBottom: "10px" }}>
                <iframe src="https://cdn.jwplayer.com/players/XAoiizto-1cjcgivg.html" width="100%" height="100%" frameBorder="0" scrolling="auto" title="Clarín - Mas visto - sin video loop" style={{ position: "absolute", margin: "inherit !important" }} allowFullScreen />
              </div>
              <DiscoverNews title="Te puede interesar" innerWidth={formatContent?.innerWidth} isPreview={rest?.isPreview} idBucket="discover-lx" />
              <DiscoverNews innerWidth={formatContent?.innerWidth} isPreview={rest?.isPreview} title="Selección Clarín" idBucket="seleccion-clarin-lx" limit={3} suscribersOnly={true} idNew={formatContent?._id} />
              <Tag />
            </StoryBody>
            <div className="columnContainer">
              <div className="column">
                <RightColumn />
              </div>
            </div>
          </StoryGrid>
        </VideoStory>
      </ContainerAuto>
      <Meter />
      <Autorefresh timerRefresh={600} />
      <Footer />
    </TemplateProvider>
  );
};

export default Video;
